import moment from 'moment'
import { REQUEST_DATA_SUCCESS, LOAD_DATA_SUCCESS } from './mutation-types'

export default {
  [REQUEST_DATA_SUCCESS](state, payload) {
    state.tabs = payload.map(({ Id, Nome }) => {
      return {
        cadeia: Id,
        nome: Nome,
        items: [],
        reload: true,
        pagination: {
          page: 1,
          pageCount: 0,
          pageSize: 10,
          totalCount: 0
        },
        filters: {
          ano: '',
          mes: '',
          nome: '',
          pageSize: '10',
          page: '1',
          publico: ''
        }
      }
    })
  },

  [LOAD_DATA_SUCCESS](state, { tipo, data }) {
    const { Result, Page, PageCount, PageSize, TotalCount } = data
    const tab = state.tabs.find(t => t.cadeia === tipo)
    if (tab) {
      tab.pagination = {
        page: Page,
        pageCount: PageCount,
        pageSize: PageSize,
        totalCount: TotalCount
      }
      tab.items = Result.map(i => {
        i.fData = moment(i.Data).format('L')
        return i
      })
    }
  }
}
